/**
 * Google Consent Mode v2 integration.
 * Sets default denied signals on load, updates on consent.
 *
 * Reference: https://developers.google.com/tag-platform/security/guides/consent
 */

type ConsentMode = "granted" | "denied";

interface GtagConsentParams {
  ad_storage: ConsentMode;
  ad_user_data: ConsentMode;
  ad_personalization: ConsentMode;
  analytics_storage: ConsentMode;
  [key: string]: ConsentMode;
}

function gtag(...args: unknown[]): void {
  // Push to dataLayer (Google Tag Manager pattern)
  const w = window as unknown as { dataLayer: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(arguments);
}

/**
 * Set default denied state. Call this BEFORE any Google tags load.
 */
export function setDefaultDenied(): void {
  gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    wait_for_update: 500,
  } as unknown as GtagConsentParams);
}

/**
 * Update consent signals based on user choice.
 */
export function updateConsentMode(consent: Record<string, boolean>): void {
  const params: GtagConsentParams = {
    ad_storage: consent["marketing"] ? "granted" : "denied",
    ad_user_data: consent["marketing"] ? "granted" : "denied",
    ad_personalization: consent["marketing"] ? "granted" : "denied",
    analytics_storage: consent["analytics"] ? "granted" : "denied",
  };

  gtag("consent", "update", params);
}
